import React, { useState, useEffect } from "react";

import swal from "sweetalert";
import { Form, Input, FormField, FormGroup, Button } from "semantic-ui-react";

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Footer from "../../../../components/Footer";

import { producaov2 } from "../../../../services/apis";

import { Container, Box, Header, FormBlock } from "./styles";

import { getUserNode } from "../../../../services/auth_node";

const RelatorioPesquisaMBA = () => {
  document.title = "Painel Administrativo | Grupo Voitto";

  const [dataInicio, setDataInicio] = useState("");
  const [dataFinal, setDataFinal] = useState("");
  const [reportUrl, setReportUrl] = useState('');
  const [loadingReport, setLoadingReport] = useState(false);

  const generateReport = async () => {
    if(!dataInicio || !dataFinal) {
      return swal("Período da pesquisa obrigatório", "Atualize o período do relatório e tente novamente", "warning");
    }

    setLoadingReport(true);

    try {
      const response = await producaov2.post('/admin/reports/pesquisa-mba', {
        data_inicio: dataInicio,
        data_final: dataFinal
      });
  
      setReportUrl(response.data.url);
    } catch(error) {
      swal('Houve um erro ao gerar a auth_key', 'Contate TI para verificar o problema', 'error');
    } finally {
      setLoadingReport(false);
    }
  }

  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>

      <AdminMenu />
      <Container>
        <Header>Relatório de Pesquisa (NPS MBA)</Header>
        <Box>
          <Form>
            <FormBlock>
              <p>Selecionar período</p>
              <FormField>
                A partir de
                <Input
                  onChange={(e) => setDataInicio(e.target.value)}
                  type="date"
                />
                até
                <Input
                  onChange={(e) => setDataFinal(e.target.value)}
                  type="date"
                />
              </FormField>
            </FormBlock>

            <FormGroup>
              {reportUrl ? (
                <Button
                  as="a"
                  href={reportUrl}
                  onClick={() => setReportUrl('')}
                  style={{ minWidth: "80px" }}
                  color="green"
                >
                  Baixar Relatório
                </Button>
              ) : (
                <Button
                  color="orange"
                  onClick={generateReport}
                  disabled={loadingReport}
                >
                  {loadingReport ? 'Gerando...' : 'Gerar Relatório'}
                </Button>
              )}
            </FormGroup>
          </Form>
        </Box>
      </Container>
      <Footer />
    </div>
  );
};

export default RelatorioPesquisaMBA;
